
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Option } from '../../../core/models/option.model';
import { Subscription } from 'rxjs';
import { FormErrorsModule } from '@spartacus/storefront';
import { I18nModule, WindowRef } from '@spartacus/core';

@Component({
  selector: 'amorph-select',
  standalone: true,
  imports: [I18nModule, ReactiveFormsModule, FormsModule, FormErrorsModule],
  templateUrl: './amorph-select.component.html',
  styleUrl: './amorph-select.component.scss',
})
export class AmorphSelectComponent implements OnInit, OnDestroy {
  @ViewChild('container') container!: ElementRef;

  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() items: Option[] = [];
  @Input() type: string = 'select';

  subscription = new Subscription();

  constructor(private winref: WindowRef) {}

  ngOnInit(): void {
    this.checkValue();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkValue() {
    this.subscription.add(
      this.form.get(this.controlName)?.valueChanges.subscribe(value => {
        if (value === 'amorphSelect-input') {
          this.setType('input');
          this.form.get(this.controlName)?.setValue('');

          setTimeout(() => {
            if (this.winref.isBrowser()) {
              const $container = this.container.nativeElement as HTMLDivElement;
              const $input = $container.querySelector('.js-input') as HTMLInputElement;
              $input?.focus();
            }
          }, 50);
        }

        if (value === 'amorphSelect-select') {
          this.setType('select');
        }
      }),
    );
  }

  backToSelect() {
    this.setType('select');
    this.form.get(this.controlName)?.setValue('');
  }

  setType(type: string) {
    this.type = type;
  }
}
